import { Icon, IconButton, TableBody, TableItem, Text, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

import { messageError } from '../../../../../../Resume/utils';
import { handleExportSentOrder, rowHeight, widthCols } from '../constants';

import { StatusIcon } from './StatusIcon';

import { SentOrderItemProps } from '.';

const vStackSpace = Spacing['stack.quarck'];

export const Tablet: React.FC<SentOrderItemProps> = ({ order, onSelect }) => {
  const handleSelect = () => {
    onSelect?.(order);
  };

  return (
    <TableBody testId={'table-order-history-body'} height={rowHeight.tablet} spaceX="inset.xs">
      <TableItem
        testId={`table-order-history-order-${order.orderId}`}
        width={widthCols.document.tablet}>
        <Pressable testID="order-history-button-icon" onPress={() => handleExportSentOrder(order)}>
          <Icon
            testID="order-history-icon"
            name="Pdf"
            size="xs"
            color={Color['brand.tertiary.principal']}
          />
        </Pressable>
      </TableItem>
      <TableItem testId={'table-order-history-order-id'} width={widthCols.orderId.tablet}>
        <VStack space={vStackSpace}>
          <Text variant="bold">Ordem</Text>
          <Text>{order?.orderHash || messageError}</Text>
        </VStack>
      </TableItem>
      <TableItem testId={'table-order-history-order-date'} width={widthCols.sentDate.tablet}>
        <VStack space={vStackSpace}>
          <Text variant="bold">Data de envio</Text>
          <Text>{order.orderDateNormalized}</Text>
        </VStack>
      </TableItem>
      <TableItem testId={'table-order-history-create-date'} width={widthCols.customerName.tablet}>
        <VStack space={vStackSpace}>
          <Text variant="bold">Cliente</Text>
          <Text>{order.customerNormalized.customerNameNormalized}</Text>
        </VStack>
      </TableItem>
      <TableItem testId={'table-order-history-create-date'} width={widthCols.account.tablet}>
        <VStack space={vStackSpace}>
          <Text variant="bold">Conta</Text>
          <Text>{order.accountNormalized.custodyNumberNormalized}</Text>
        </VStack>
      </TableItem>
      <TableItem testId={'table-order-history-create-date'} width={widthCols.product.tablet}>
        <VStack space={vStackSpace}>
          <Text variant="bold">Produto</Text>
          <Text>{order.marketTypeNormalized}</Text>
        </VStack>
      </TableItem>
      <TableItem
        testId={'table-order-history-create-date'}
        align="center"
        width={widthCols.sentValue.tablet}>
        <VStack space={vStackSpace}>
          <Text variant="bold">Valor enviado</Text>
          <Text>{order.requestedAmountNormalized}</Text>
        </VStack>
      </TableItem>
      <TableItem testId={'table-order-history-order-id'} width={widthCols.status.tablet}>
        <VStack space={vStackSpace}>
          <Text variant="bold">Status</Text>
          <StatusIcon order={order} withText />
        </VStack>
      </TableItem>
      <TableItem testId={'table-order-history-applied-value'} width={widthCols.details.tablet}>
        <IconButton
          onPress={handleSelect}
          icon="ChevronRight"
          iconSize="xxxs"
          testId="icon"
          iconColor={Color['brand.tertiary.principal']}
        />
      </TableItem>
    </TableBody>
  );
};
